import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { AudioPlayerService } from '../../services/audio-player.service';
import { GameType } from '../../_models/game';
import { Game } from '../../_models/model';

@Component({
  selector: 'app-game-completed',
  templateUrl: './game-completed.component.html',
  styleUrls: ['./game-completed.component.less']
})
export class GameCompletedComponent implements OnInit {
  @Input() game!: Game;
  @Input() enableReplay?: boolean;
  gameIcon!: string;
  gameFinishedText?: SafeHtml;
  @Output() close = new EventEmitter<boolean>();
  @Output() replay = new EventEmitter<boolean>();
  constructor(public audio: AudioPlayerService) {

  }

  ngOnInit(): void {
      this.gameIcon = '/img/popup/won-game-types/' + this.game.type + '.svg';
      // this.gameFinishedText = this.audio.getHTML('game_afgerond');
  }
  onClose() {
    this.close.emit(true);
  }
  onReplay() {
    this.replay.emit(true);
  }

}
